import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import DataTableHelper from "../../../helpers/tables/DataTableHelper";
import Columns from "./Columns";
import AddUpdModal from "./AddUpdModal";
import {
  resourcesOtrosEgresos,
  resourcesOperators,
  resourcesUnits,
} from "../../../helpers/backend_helper";
import { DestroyAlertHelper, Alert } from "../../../helpers/alerts/alertHelper";
import { getStorageUser } from "../../../helpers/api_helper";
import {
  Container,

  Row,
} from "reactstrap";
import ButtonHelper from "../../../helpers/ButtonHelper";
import Select from "react-select";
import PeriodFilterHelper from "../../../helpers/PeriodFilterHelper";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";

let today = dayjs();

const FuelSales = () => {
  let timeElapsed = new Date();
  let dateNow = `${timeElapsed.getFullYear()}-${
    timeElapsed.getMonth() + 1 < 10 ? "0" : ""
  }${timeElapsed.getMonth() + 1}-${timeElapsed.getDate()}`;
  const { report } = useParams();
  const authUser = getStorageUser();
  const [pending, setPending] = useState(false);
  const [modal, setModal] = useState({ show: false, update: false });
  const [modalFile, setModalFile] = useState({
    show: false,
    id: null,
    files: [],
  });
  const [selects, setSelects] = useState({
    operadores: [],
    operator: null,
    units: [],
    unit: null,
  });
  const [dataPag, setDataPag] = useState({ total: 0 });
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 20,
    search: "",
    orderBy: "id",
    order: "asc",
    unidad_id: null,
    operador_id: null,
    initDate: dayjs().startOf("day").toDate(),
    endDate: dayjs().endOf("day").toDate(),
  });
  const [items, setItems] = useState([]);
  const [modalPdf, setModalPdf] = useState({ show: false });
  const itemBase = {
    id: null,
    unidad_id: null,
    operador_id: null,
    concepto: "",
    monto: "",
    fecha: today.format('YYYY-MM-DD'),
    route_id: null,
  };
  const [item, setItem] = useState(itemBase);
  useEffect(() => {
    const getOtrosEgresos = async () => {
      let params = { params: {
        ...filters,
        initDate: dayjs(filters.initDate).format("YYYY-MM-DD HH:mm"),
        endDate: dayjs(filters.endDate).format("YYYY-MM-DD HH:mm"),
      } };
      setPending(true);
      const response = await resourcesOtrosEgresos("get", params);
      setItems(response.data);
      setDataPag(response.meta);
      setPending(false);
    };
    getOtrosEgresos();
  }, [filters]);

  const getReports = async (type) => {
    let config = {
      params: {
        ...filters,
        initDate: dayjs(filters.initDate).format("YYYY-MM-DD HH:mm"),
        endDate: dayjs(filters.endDate).format("YYYY-MM-DD HH:mm"),
      },
      headers: {
        Accept:
          type == 2
            ? "application/pdf"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      responseType: "blob",
    };
    const exportSalidas = await resourcesOtrosEgresos("get", config);
    if (type == 1) {
      const url = URL.createObjectURL(new Blob([exportSalidas]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Salidas.xlsx");
      document.body.appendChild(link);
      link.click();
    } else {
      let nombre = "Archivo";
      var reader = new FileReader();
      reader.readAsDataURL(exportSalidas);
      reader.fileName = nombre[1] || nombre[0];
      reader.onloadend = function (name) {
        name = nombre[0];
        var base64data = reader.result;
        setModalPdf({ show: true, update: false, url: base64data });
      };
    }
  };

  useEffect(() => {
    const getSelects = async () => {
      let params = { params: { select: true } };
      const operadores = await resourcesOperators("get", params);
      const units = await resourcesUnits("get", params);
      setSelects({
        ...selects,
        operators: operadores.data,
        units: units.data,
      });
    };
    getSelects();
  }, []);

  const addUpd = (row) => {
    setItem(row?.id ? {...row, fecha: dayjs(row.fecha).format('YYYY-MM-DD') } : itemBase);
    setModal({ ...modal, show: true, update: row?.id ? true : false });
  };

  const destroy = async (id) => {
    DestroyAlertHelper(async (confirmed) => {
      if (!confirmed) {
        return;
      }
      const response = await resourcesOtrosEgresos("del", id, id);
      Alert(response.message, response.status);
      if (response.status) {
        setItems(items.filter((i) => i.id != id));
      }
    });
  };

  const columns = Columns(addUpd, destroy, setModalFile, modalFile, report);

  document.title = report ? "Reporte Otros Egresos" : "Otros Egresos";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="col-12">
            <DataTableHelper
              filterInp={false}
              tittle={report ? "Reporte Otros Egresos" : "Otros Egresos"}
              columns={columns}
              items={items}
              pending={pending}
              config={dataPag}
              filters={filters}
              setFilters={setFilters}
            >
              <div className="mb-3">
                <ButtonHelper
                  actionSave={report ? false : addUpd}
                  addButon={report ? false : true}
                  actionAddButon={() => (report ? false : addUpd(item))}
                  reportButons={true}
                  actionReportButon={getReports}
                />
              </div>
              <Row>
              <PeriodFilterHelper
                  setFilters={setFilters}
                  filters={filters}
                  initTime={true}
                  endTime={true}
                  modal={modalPdf}
                  setModal={setModalPdf}
                />
                <div className="col-sm-2">
                  <label className="form-label">Unidades:</label>
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    isClearable={true}
                    defaultValue={selects.unit}
                    isSearchable={false}
                    name="unit"
                    placeholder="Unidades"
                    options={selects.units}
                    getOptionLabel={(option) => `${option.number}`}
                    getOptionValue={(option) => `${option.id}`}
                    onChange={(e) => [
                      setSelects({ ...selects, unit: e }),
                      setFilters({ ...filters, unidad_id: e ? e.id : null }),
                    ]}
                  />
                </div>
                <div className="col-sm-2">
                  <label className="form-label">Operador:</label>
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    isClearable={true}
                    defaultValue={selects.operador}
                    isSearchable={false}
                    name="operator"
                    placeholder="Operadores"
                    options={selects.operators}
                    getOptionLabel={(option) => option.full_name}
                    getOptionValue={(option) => `${option.id}`}
                    onChange={(e) => [
                      setSelects({ ...selects, operador: e }),
                      setFilters({ ...filters, operador_id: e ? e.id : null }),
                    ]}
                  />
                </div>
              </Row>
            </DataTableHelper>
          </div>
        </Container>
        {modal.show && (
          <AddUpdModal
            modal={modal}
            setModal={setModal}
            items={items}
            setItems={setItems}
            item={item}
            setItem={setItem}
            authUser={authUser}
            filtersItems={filters}
            setFiltersItems={setFilters}
            selects={selects}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default FuelSales;
